export const SET_PRISMIC_DOCUMENT_UID = 'SET_PRISMIC_DOCUMENT_UID';
export const SET_OVERVIEW_NAV_TAB_IDX = 'SET_OVERVIEW_NAV_TAB_IDX';
export const SET_BREEDER_POST_DATA = 'SET_BREEDER_POST_DATA';

export function setPrismicDocumentUid(uid) {
  return {
    type: SET_PRISMIC_DOCUMENT_UID,
    payload: {
      prismicDocumentUid: uid
    }
  };
}

export function setBreedOverviewNavTabIdx(idx) {
  return {
    type: SET_OVERVIEW_NAV_TAB_IDX,
    payload: {
      overviewNavTabIdx: idx
    }
  };
}

export function setBreederPostData(postId, mediaIdx) {
  return {
    type: SET_BREEDER_POST_DATA,
    payload: {
      breederPostData: {
        post_id: postId,
        media_idx: mediaIdx
      }
    }
  };
}
